import React, { useState } from 'react'
import moment from 'moment'
import { Tooltip, IconButton, TableCell, TableRow } from '@mui/material'
import Delete from './Delete'
import Form from './Form'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { usePatchCnn } from '../../api/cnn'
import { TicketOverrideBadge } from '../shared/TicketOverrideBadge'

const Row = ({ data, refetch }) => {
  const [editing, setEditing] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)

  const formDefaultValues = {
    ...data,
  }

  return (
    <>
      <TableRow>
        <TableCell>{data.name}</TableCell>
        <TableCell>{data.bonusT2Tickets}</TableCell>
        <TableCell>
          <TicketOverrideBadge overrides={data.ticketOverrides} />
        </TableCell>
        <TableCell>
          <Tooltip title={moment(data.updatedAt).format('h:mm a, DD/MM/YYYY')}>
            <span>{data.updatedBy.name}</span>
          </Tooltip>
        </TableCell>
        <TableCell>
          <Tooltip title='Edit'>
            <IconButton color='primary' onClick={() => setEditing(true)} size='small'>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell>
          <Tooltip title='Delete'>
            <IconButton color='error' onClick={() => setOpenDelete(true)} size='small'>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
      <Form
        defaultValues={formDefaultValues}
        open={editing}
        setOpen={setEditing}
        refetch={refetch}
        api={usePatchCnn}
        isEdit={true}
      />
    </>
  )
}

export default Row
